import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const EvtVisualBannerItem = styled.div`
  position: relative;
`;

export const ImgWrap = styled.div`
  position: relative;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .img {
    padding-bottom: 58.80597015%;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    .img {
      padding-bottom: 100%;
    }
  }
`;

export const AreaInfo = styled(Button)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  padding: 0 20px;

  .sub-title,
  .title {
    display: block;
    line-height: 130%;
    ${mixin.ellipsis(1)};
  }

  .title {
    font-weight: 600;
    font-size: 20px;
    color: #fff;
  }

  .sub-title {
    font-size: 14px;
    margin-top: 2px;
    color: #e2e2e2;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 20')};

    .title {
      font-size: ${mixin.pxToVw('20')};
    }

    .sub-title {
      font-size: ${mixin.pxToVw('14')};
      margin-top: ${mixin.pxToVw('2')};
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    .title {
      font-size: 32px;
    }

    .sub-title {
      margin-top: 2px;
      font-size: 20px;
    }
  }
`;
